//
//
//
//
//
//
//
//
//
//
//
//
//

import QiniuImg from './QiniuImg.vue'

export default {
  name: 'RecommendLeague',
  props: {
    leagues: {
      type: Array,
      required: true,
    },
  },
  components: {
    QiniuImg,
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/RecommendLeague.vue